import links from "@/links/links";

export default {
  actions: {
    FETCH(meetingId /** ???: queryParams, still needed here ?? */) {
      return this.get(links.MEETING_MANDATES(meetingId), {
        dataKey: "hydra:member",
      });
    },
    QUERY_FETCH(agencyId, queryParams, relatedId /** ???: queryParams, still needed here ?? */) {
      return this.get(links.MANDATE_QUERY_FETCH(relatedId), {
        dataKey: "hydra:member",
      });
    },
    GET(id) {
      return this.get(links.MANDATE_GET(id));
    },
    POST(item, forSendingNotifs = false) {
      return this.post(links.MANDATE_POST(), item, {
        save: !forSendingNotifs ? true : false,
      });
    },
    PUT(item) {
      return this.put(links.MANDATE_PUT(item.id), item);
    },
    DELETE(item) {
      return this.delete(links.MANDATE_DELETE(item.id), {
        delete: item.id,
      });
    },
    UPDATE_MULTIPLE_LAST_SEEN(mandates) {
      return this.post(links.MANDATE_UPDATE_MULTIPLE_LAST_SEEN(), { mandates }, { save: false });
    },
    MANDATE_CORRESPONDENCE_VOTING(item) {
      return this.post(links.MANDATE_CORRESPONDENCE_VOTING(), item, { save: false });
    },
    MANDATE_GET_DEFAULT_INVITATION_BROADCAST(meetingId) {
      return this.get(links.MANDATE_GET_DEFAULT_INVITATION_BROADCAST(meetingId), {
        dataKey: "hydra:member",
      });
    },
    MANDATE_GET_MANUAL_INVITATION_BROADCAST(meetingId) {
      return this.get(links.MANDATE_GET_MANUAL_INVITATION_BROADCAST(meetingId), {
        dataKey: "hydra:member",
      });
    },
    FETCH_WITHOUT_RESOLUTION_VOTES(meetingId) {
      return this.get(links.MEETING_MANDATES_WITHOUT_RESOLUTION_VOTES(meetingId), {
        dataKey: "hydra:member",
      });
    },
    GET_DOC_REQUESTS(id) {
      return this.get(links.MANDATE_GET_DOC_REQUESTS(id), {
        save: false,
      });
    },
    GET_DOCS_BY_MEETING(queryParams) {
      var processedQueryParams = {};
      processedQueryParams.meetingId = queryParams.meetingId;
      processedQueryParams.page = queryParams.page;
      processedQueryParams.itemsPerPage = queryParams.itemsPerPage;
      processedQueryParams.orderByBoName = queryParams.orderByBoName;
      processedQueryParams.searchParams = queryParams.searchParams;
      return this.get(links.GET_MANDATES_DOCS_BY_MEETING(), {
        params: processedQueryParams,
        save: false,
      });
    },
  },
};
